import * as Preact from "preact"

import App from "@frog/source/models/App.js"
import Dev from "@frog/source/models/dev/Dev.js"
import Navigation from "@frog/source/engine/navigating/Navigation.js"

import "@frog/source/views/components/PauseMenu.less"

export default class PauseMenu {
    render() {
        if(Navigation.state.escape == undefined) return
        return (
            <div class="PauseMenu">
                <div class="Grayout" onClick={() => Navigation.state.escape = undefined}/>
                <div class="PlayerOptions" onClick={(event) => event.stopPropagation()}>
                    <div class="Header">PAUSED</div>
                    <div class="Option" onClick={() => Navigation.go(this.url)}>{App?.game?.pauseMenu?.text || "Main Menu"}</div>
                    <hr/>
                    <div class="Option" onClick={this.restart}>Restart</div>
                    <div class="Option" onClick={() => Navigation.state.escape = undefined}>Resume</div>
                </div>
                {this.dev}
            </div>
        )
    }
    get url() {
        if(App?.game == undefined) {
            return "/title"
        }
        if(App.game.pauseMenu != undefined) {
            return App.game.pauseMenu.url
        }
        return "/games/" + App.game.slug + "/title"
    }
    get dev() {
        if(Dev.isEnabled != true) return
        return (
            <div class="Dev" onClick={(event) => event.stopPropagation()}>
                <div class="Options">
                    <div class="Option" onClick={this.killAllEnemies}>💀</div>
                </div>
            </div>
        )
    }
    restart() {
        Navigation.state.escape = undefined
        App.game.chapter.restart()
    }
    toggleDeath() {
        Dev.isAllyDeathEnabled = !Dev.isAllyDeathEnabled
        App.game.chapter.recalculateStage()
    }
    toggleCollision() {
        Dev.isAllyCollisionEnabled = !Dev.isAllyCollisionEnabled
        App.game.chapter.recalculateStage()
    }
    killAllEnemies() {
        App.game.chapter.actionTrace.push({"type": "killAllEnemies"})
        App.game.chapter.killAllEnemies()
    }
}
